module.exports = __webpack_public_path__ + "static/media/logo-poupa-energia-footer.ad1c2be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/RatingFooter/logo-poupa-energia-footer.png
// module id = 1675
// module chunks = 0